import React, { useContext } from "react";
import { CustomerAreaContext } from "~/assets/js/pages/CustomerArea/CustomerAreaProvider";
import GoBackTitle from "~/assets/js/pages/CustomerArea/components/GoBackTitle";
import Button from "~/assets/js/components/Button";
import OrderItems from "~/assets/js/components/OrderItems";
import i18next from "i18next";
import { Download } from "react-feather";
import ReorderContainer from "~/assets/js/components/Reorder";
import OrderType from "~/assets/js/components/OrderCard/OrderType";
import OverviewSection from "~/assets/js/pages/Checkout/sections/OrderOverview/OverviewSection";
import AddressSelected from "../../../Checkout/sections/OrderOverview/AddressSelected";
import OrderTypeOfPayment from "~/assets/js/components/OrderTypeOfPayment";
import OrderDeliverySlot from "~/assets/js/components/OrderDeliverySlot";
import OrderSummary from "~/assets/js/components/CheckoutSummary/OrderSummary";
import useAreaCookie from "~/assets/js/Helpers/hooks/useAreaCookie";
import { isEmpty } from "lodash";

const PATH = "orderDetail";

const OrderDetail = () => {
    const { state } = useContext(CustomerAreaContext);
    const { selectedOrder } = state;
    const isPickup = selectedOrder.dispatch_type === "pickup";
    const cookie = useAreaCookie();

    return (
        <>
            <GoBackTitle path={PATH} />
            <div>
                <div className="order-detail">
                    <div className="order-detail_actions">
                        {!selectedOrder.invoice_url ? (
                            <span>
                                {i18next.t(
                                    "customerArea.ordersOverview.invoiceAvailableSoon"
                                )}
                            </span>
                        ) : (
                            <Button
                                variant="secondary"
                                label={i18next.t(
                                    "customerArea.ordersOverview.downloadReceipt"
                                )}
                                icon={<Download />}
                                href={selectedOrder.invoice_url}
                                customStyle="order-detail_actions_button"
                            />
                        )}
                    </div>

                    <OrderItems orderItems={selectedOrder.items} />

                    <OverviewSection title="overview.orderType">
                        <OrderType
                            order={selectedOrder}
                            isPickup={isPickup}
                            storeId={selectedOrder.store_id}
                        />
                    </OverviewSection>

                    <OrderDeliverySlot
                        slotBegin={selectedOrder.slot_begin}
                        slotEnd={selectedOrder.slot_end}
                        earlierAllowed={
                            selectedOrder?.shipping?.earlier_allowed
                        }
                        isPickup={isPickup}
                    />

                    {!isPickup && (
                        <AddressSelected
                            title="overview.delivery"
                            address={selectedOrder.shipping}
                        />
                    )}

                    <AddressSelected
                        title="overview.billing"
                        address={selectedOrder.billing}
                    />
                </div>

                <OrderTypeOfPayment
                    paymentOption={selectedOrder.payment.payment_method}
                />
                <OrderSummary order={selectedOrder} />
            </div>
        </>
    );
};

export default OrderDetail;
